import React, { PropTypes, Component } from 'react';
import DropdownMenu from 'common/components/dropdown_menu';
import { ADMIN_ROOT } from 'common/variables';

export default class ActionsMenu extends Component {
  render() {
    const { onToggle, entry } = this.props;
    const entryLink = `${ADMIN_ROOT}/project/${entry.project}/entry/${entry.id}/`;
    const projectLink = `${ADMIN_ROOT}/project/${entry.project}/`;

    const buttons = [{
      label: <span><i className="fa fa-external-link" /> Go to entry</span>,
      url: entryLink,
      target: "_blank",
      show: true
    }, {
      label: <span><i className="fa fa-external-link" /> Go to project</span>,
      url: projectLink,
      target: "_blank",
      show: true
    }];

    return <DropdownMenu buttons={buttons} className="tile-menu" onToggle={onToggle} />;
  }
}

ActionsMenu.propTypes = {
  onToggle: PropTypes.func.isRequired,
  entry: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./admin/components/user_entries/actions_menu.jsx